import {api} from 'shared/core';
import {endpoints} from 'main/tools';
import {computed} from 'mobx';

class UserActivationState {
  load() {
    setTimeout(
      async () => {
        await api.post(endpoints.USER_ACTIVATIONS.with(this.token));

        window.location = '/';
      }, 1000);
  }

  @computed get token() {
    return window.location.pathname.split('/').at(-1);
  }}

export default UserActivationState;
